<template>
  <customModal :containermd="true" :footerShow="false" @closeModal="closeSetRange()">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.lab reference") }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
          <div class="mb-1">
            <div class="me-3 d-flex justify-content-end align-items-center">
              <label class="mb-0 me-2">
                {{ $t("navigations.versions") }}
                <select class="form-select form-select-sm d-inline-block w-auto py-0" v-model="selectedVersion"
                  @change="onVersionChange">
                  <option value="" disabled>Select version</option>
                  <option v-for="ver in versionList" :key="ver" :value="ver">
                    {{ ver }}
                  </option>
                </select>
                
              </label>
              <label class="mb-0">
                  <span class="position-relative">
                    <img
                      class="cursor-pointer" style="padding-bottom:1px;"
                      src="../../assets/img/create.png"
                      @click.prevent="openVersionModal()" 
                    />
                    <div class="tool-tip">{{ $t("navigations.add new version") }}</div>
                  </span>
                </label>
              <div class="d-flex align-items-center ms-2">
                <div 
        class="me-2 position-relative"
        v-if="showApproveBtn" >
      
          <img
            src="../../assets/img/Approve_Study.png"
            alt="approval_status"
            @click="openApproveModal()"
             class="cursor-pointer"
            style="width: 20px; height: 20px;"

            />
             <div class="tool-tip">{{ $t("navigations.approve") }}</div>
            
      </div>
                <div class="me-2 position-relative" v-if="versionList.length > 0">
          <img
            src="../../assets/img/assign_approver.svg"
            alt="Assign Approver"
            @click="openApprovalModal"
            class="cursor-pointer"
            style="width: 20px; height: 20px;"
          />
          <div class="tool-tip">{{ $t("navigations.assign approver") }}</div>
        </div>
              </div>
            </div>
          </div>

          <!-- Header Section -->
          <div class="ibox-content">
            <div class="mb-3 p-3 border rounded bg-light">
              <div class="row align-items-center g-3">
                <div class="col-md-2">
                  <div>
                    <small class="text-muted d-block fw-semibold">{{ $t("navigations.test code") || "Test Code" }}</small>
                    <span class="fw-medium">{{ testCode || '-' }}</span>
                  </div>
                </div>
                
                <div class="col-md-2">
                  <div>
                    <small class="text-muted d-block fw-semibold">{{ $t("navigations.unit") || "Unit" }}</small>
                    <span class="fw-medium">{{ unit!=""?unit: unitselected }}</span>
                  </div>
                </div>
                
                <div class="col-md-2">
                  <div>
                    <small class="text-muted d-block fw-semibold">{{ $t("navigations.version no") || "Version No" }}</small>
                    <span class="fw-medium">{{ selectedVersion || '-' }}</span>
                  </div>
                </div>
                
                <div class="col-md-2">
                  <div>
                    <small class="text-muted d-block fw-semibold">{{ $t("navigations.effective date") || "Effective Date" }}</small>
                    <span class="fw-medium">{{ formatDate(effectiveDate) || '-' }}</span>
                  </div>
                </div>
                
                <div class="col-md-2">
                  <div>
                    <small class="text-muted d-block fw-semibold">{{ $t("navigations.status") || "Status" }}</small>
                    <span :class="isActive ? 'badge bg-success' : 'badge bg-danger'">
                      {{ isActive ? 'Active' : 'Inactive' }}
                    </span>
                  </div>
                </div>
<div class="col-md-2">
  <div>
    <small class="text-muted d-block fw-semibold">
      {{ $t("navigations.approval status") || "Approval Status" }}
    </small>

    <div class="d-flex align-items-center gap-2">
      <span :class="{
        'badge bg-warning': approvedStatus === 'Pending',
        'badge bg-success': approvedStatus === 'Approved',
        'badge bg-danger': approvedStatus === 'Rejected'
      }">
        {{ approvedStatus || '-' }}
      </span>
      <span class="position-relative">
        <i class="fa fa-eye edit-delete cursor-pointer"
           @click.prevent="viewAssigners">
        </i>
        <div class="tool-tip">
          {{ $t("navigations.view approvers") }}
        </div>
      </span>
    </div>
  </div>
</div>


              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="mb-0">
                {{ $t("navigations.range list") || "Test Range List" }}
              </h4>

             <div class="position-relative" v-if="versionList.length > 0">
  <img
    class="cursor-pointer"
    src="../../assets/img/create.png"
    alt="Create study"
    style="width: 20px; height: 20px;"
    @click.prevent="showAddRangeModal()"
  />
  <div class="tool-tip">{{ $t("navigations.add new reference") }}</div>
</div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th>Subject Classification</th>
                    <th>Age Min</th>
                    <th>Age Max</th>
                    <th>Min Range</th>
                    <th>Max Range</th>
                    <th>Range Severity</th>
                    <th class="text-center">{{ $t("navigations.edit") }}</th>
                    <th class="text-center">{{ $t("navigations.delete") }}</th>
                    <th class="text-center"> {{ $t("navigations.validation") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="result in labList" :key="result.id">
                    <td>{{ result.gender }}</td>
                    <td>{{ result.ageMin }}</td>
                    <td>{{ result.ageMax }}</td>
                    <td>{{ result.ranges[0]?.valueMin }}</td>
                    <td>{{ result.ranges[0]?.valueMax }}</td>
                    <td>{{ result.ranges[0]?.qualitative }}</td>
                    <td class="text-center">
                      <i class="fa fa-edit edit-delete" @click.prevent="editlabtest(result.id)"></i>
                    </td>
                    <td class="text-center">
                      <i class="fa fa-trash edit-delete" @click.prevent="deleteLabs(result.id)"></i>
                    </td>
                    <td class="text-center">
                      <i class="fa fa-plus-circle edit-delete" @click.prevent="openValidationModal(result.id)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="labList.length != 0">
                <VPagination v-model="currentPage" :pages="totalItems" :range-size="1" active-color="#ededed"
                  @update:modelValue="getLabMaster" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>

  <!-- Add Range Modal -->
  <customModal :containersm="true" :footerShow="false" v-if="showAddRangeVersionModal" @closeModal="closeRange">
    <template #title>
      <h4 class="my-0">
        {{ isEditing ? $t("navigations.update lab reference") : $t("navigations.add new reference") }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="versionInput">
                {{ $t("navigations.version no") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <input id="versionInput" v-model="versionNo" type="text" class="form-control" :disabled="isVersionLocked" />
              <span v-if="versionNoError" class="errormsg">
                {{ $t("navigations.please enter a value.") }}
              </span>
            </div>

            <div class="col-md-6">
              <label>{{ $t("navigations.unit") }}
                <sup><i class="fa fa-asterisk imp"></i></sup></label>
              <input v-model="unit" type="text" class="form-control" :disabled="isVersionLocked" />
              <span v-if="unitError" class="errormsg">
                {{ $t("navigations.please enter a value") }}
              </span>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <label for="genderSelect">{{ $t("navigations.subject classification") }}</label>
              <sup><i class="fa fa-asterisk imp"></i></sup>
              <select id="genderSelect" v-model="gender" class="form-control">
                <option value="" disabled selected>
                  {{ $t("navigations.select subject classification") }}
                </option>
                <option value="Male">{{ $t("navigations.male") || "Male" }}</option>
                <option value="Female">{{ $t("navigations.female") || "Female" }}</option>
                <option value="Pregnant">{{ $t("navigations.pregnant") || "Pregnant" }}</option>
                <option value="All">{{ $t("navigations.all") || "All" }}</option>
              </select>
              <span v-if="genderError" class="errormsg">
                {{ $t("navigations.please select a value") }}
              </span>
            </div>

            <div class="col-md-3">
              <label>{{ $t("navigations.min age") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <input v-model.number="ageMin" type="number" class="form-control" 
                @blur="validateAgeMin" @input="validateAgeMin" min="0" />
              <span v-if="ageErrors[0]" class="errormsg">
                {{ $t("navigations.please enter a valid min age") }}
              </span>
            </div>

            <div class="col-md-3">
              <label>{{ $t("navigations.max age") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <input v-model.number="ageMax" type="number" class="form-control" 
                @blur="validateAgeMax" @input="validateAgeMax" min="0" />
              <span v-if="ageErrors[1]" class="errormsg">
                {{ $t("navigations.please enter a valid max age") }}
              </span>
              <span v-if="ageErrors[2]" class="errormsg">
                {{ $t("navigations.max age must be greater than min age") }}
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <hr style="border-top: 1px solid #dcdcdc; margin: 15px 0;" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label>{{ $t("navigations.min range") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
             <input v-model="minRangeValue" type="number" class="form-control" 
  @blur="validateMinRange" @input="validateMinRange" step="any" />
              <span v-if="rangeErrors[0]" class="errormsg">
                {{ $t("navigations.please enter a valid min range") }}
              </span>
            </div>

            <div class="col-md-3">
              <label>{{ $t("navigations.max range") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
             
<input v-model="maxRangeValue" type="number" class="form-control" 
  @blur="validateMaxRange" @input="validateMaxRange" step="any" />
              <span v-if="rangeErrors[1]" class="errormsg">
                {{ $t("navigations.please enter a valid max range") }}
              </span>
              <span v-if="rangeErrors[2]" class="errormsg">
                {{ $t("navigations.max range must be greater than min range") }}
              </span>
            </div>

            <div class="col-md-6">
              <label>{{ $t("navigations.range severity") }}
                <sup><i class="fa fa-asterisk imp"></i></sup>
              </label>
              <select v-model="rangeSeverity" class="form-control">
                <option value="" disabled selected>
                  {{ $t("navigations.select range severity") }}
                </option>
                <option value="Very Low">{{ $t("navigations.very low") || "Very Low" }}</option>
                <option value="Low">{{ $t("navigations.low") || "Low" }}</option>
                 <option value="Normal">{{ $t("navigations.normal") || "Normal" }}</option>
                <option value="High">{{ $t("navigations.high") || "High" }}</option>
                <option value="Very High">{{ $t("navigations.very high") || "Very High" }}</option>
              </select>
              <span v-if="rangeErrors[3]" class="errormsg">
                {{ $t("navigations.please select a value") }}
              </span>
            </div>
          </div>

          <div class="text-end mt-3">
            <button type="button" class="save_btn py-1 px-4" @click="saveRanges">
              {{ isEditing ? $t("navigations.update") : $t("navigations.add") }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </customModal>

  <!-- Assign Approver Modal -->
  <customModal
    v-if="documentApprovalModal"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeDocumentApprovalModal()"
  >
    <template #title>
      {{ $t("navigations.assign approver") }}
    </template>
    <template #body>
      <div class="row mb-2">
        <div class="col-6">
          <label class="">{{ $t("navigations.choose role") }}</label>
          <Multiselect
            v-model="designationList"
            mode="multiple"
            :searchable="true"
            trackBy="roleName"
            valueProp="roleID"
            placeholder="Select"
            label="roleName"
            :options="roleList"
            :hideSelected="false"
            :closeOnSelect="false"
            class="multiselect-template-theme mr-0 mt-1"
            @change="onChange"
          />
        </div>
      </div>
      <h4>Users</h4>
      <div class="height-scroll">
        <table class="table fixed-header">
          <thead>
            <tr>
              <th>
                <input
                  class="mr-1"
                  type="checkbox"
                  id="selectAllDocumentApprovers"
                  @change="selectall"
                />
                Users
              </th>
              <th></th>
              <th class="text-center">Save</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in userList" :key="user.id">
              <td width="50%">
                <input
                  type="checkbox"
                  :id="user.userID"
                  v-model="isSelectedUser[index]"
                  :disabled="isDisabled[index]"
                />
                <label class="mb-0" :for="user.userID">{{ user.name }}</label>
              </td>
              <td width="30%">
                <input
                  class="mr-1"
                  type="checkbox"
                  :id="'required-' + index"
                  v-model="isRequired[index]"
                  :disabled="isDisabled[index]"
                />
                <label class="mb-0" :for="isRequired[index]">
                  {{ $t("navigations.required") }}
                </label>
              </td>
              <td width="20%" class="text-center">
                <button
                  @click.prevent="singleSaveApprover(user, index)"
                  :disabled="isDisabled[index]"
                  class="border-1 border-radius-50 bg-transparent px-2 py-0 position-relative"
                  type="button"
                  :class="{
                    'disabled-btn-cls': loadingSingleSave[index] == true,
                  }"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingSingleSave[index] == false,
                      'opacity-1': loadingSingleSave[index] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <p
                    class="mb-0"
                    :class="{
                      'opacity-1': loadingSingleSave[index] == false,
                      'opacity-0': loadingSingleSave[index] == true,
                    }"
                  >
                    {{ $t("navigations.save") }}
                  </p>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-between">
        <p class="my-0">
          *Unsaved changes will be lost if switching designations.
        </p>
        <button
          type="button"
          @click="multipleSaveApprover()"
          class="save_btn py-1 px-3 position-relative"
          :disabled="loadingSaveModalBtn == true"
          :class="{ 'disabled-btn-cls': loadingSaveModalBtn == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveModalBtn == false,
              'opacity-1': loadingSaveModalBtn == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <p
            class="mb-0"
            :class="{
              'opacity-1': loadingSaveModalBtn == false,
              'opacity-0': loadingSaveModalBtn == true,
            }"
          >
            {{ $t("navigations.assign") }}
          </p>
        </button>
      </div>
    </template>
  </customModal>
  <customModal :containersm="true" :footerShow="false" v-if="showStatusModal" @closeModal="closeStatus">
    <!-- Modal Title -->
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.approvers status") }}
      </h4>
    </template>

    <template #body>
        <div class="ibox-content-edit">
          <div class="ibox-body">

            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Approvers</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(Approval, index) in approversList" :key="index">
                      <td>{{ Approval.approvedByUsername || '-' }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning': Approval.approvedStatus === 'Pending',
                          'badge bg-success': Approval.approvedStatus === 'Approved',
                          'badge bg-danger': Approval.approvedStatus === 'Rejected',
                          'badge bg-secondary': !Approval.approvedStatus
                        }">
                          {{ Approval.approvedStatus || 'Pending' }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="!approversList || approversList.length === 0">
                      <td colspan="2" class="text-center">No approvers found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
  </customModal>


  <labValidationRule 
  v-if="showValidationRule"
  :showSetRange="showValidationRule"
  :labCode="selectedLabCode"
  :testCode="selectedTestCode"
  :unitselected="unit"
  :ruleName="selectedRuleName"
  :ruleCode="selectedRuleCode"
  :gender="validationForm.gender"
  :ageMin="validationForm.ageMin"
  :ageMax="validationForm.ageMax"
  :versionNo="versionNo"
  :cdiscVariable="cdiscVariable"
  :referenceRangeId="referenceRangeId"
  @closeModal="closeValidation"
  @showSetVersion="handleShowSetVersion"
/>
  
  <labTestVersion
    v-if="showLabVersionPopup"
    :showLoading="showLoading"
    :labCode="selectedLabCode" 
    :testCode="selectedTestCode" 
    :oldVersionNo="selectedVersion"
    :currentVersion="selectedVersion"
    :unitselected="unit"
    :studyId="studyId"
    @close="closeVersionModal"
    @saved="refreshLabTestList"
    @showSetVersion="handleShowSetVersion"
  />

 <labApproveReject
  v-if="showApproveRejectPopup"
  :actionType="'Approval'"
  :itemId="studyId"
  :version="selectedVersion"
  :labCode="labCode || localLabCode"
  :testCode="testCode || localTestCode"
  @closeApproveModal="closeApproveModal()"
/>

</template>

<script src="./SetTestRanges.js">

</script>


<style scoped>
.data-grid {
  margin-top: 20px;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip{
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.position-relative img{
  width:20px;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.3rem 0.8rem;
  right: 20px;
  top: -20px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.errormsg {
  color: red;
  font-size: 12px;
}
</style>
